import { Box, IconButton, TextField, Typography } from "@mui/material";
import {
  KeyboardArrowDown as ArrowDownIcon,
  KeyboardArrowUp as ArrowUpIcon,
  Search as SearchIcon,
} from "@mui/icons-material";

export function TraceSearchPanel(props: {
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  matchingCount?: number | null;
}) {
  const { searchQuery, setSearchQuery, matchingCount } =
    props;

  return (
    <TextField
      size="small"
      placeholder="Search spans..."
      value={searchQuery}
      onChange={(e) => {
        setSearchQuery(e.target.value);
      }}
      slotProps={{
        input: {
          startAdornment: <SearchIcon sx={{ fontSize: 18, mr: 1, opacity: 0.7 }} />,
          endAdornment:
            searchQuery && matchingCount && matchingCount > 0 ? (
              <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
                <Typography variant="caption" sx={{ fontSize: 11, opacity: 0.7, mr: 0.5 }}>
                  {matchingCount}
                </Typography>
              </Box>
            ) : null,
        }
      }}
      sx={{
        minWidth: 300,
      }}
    />
  );
}
